import {ButtonHTMLAttributes, forwardRef, MouseEvent, ReactNode} from "react";
import classNames from "classnames";

type ButtonProps = {
    isLoading?: boolean;
    isDisabled?: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement, MouseEvent> | any) => void ;
    variant?: "primary" | "secondary" | "success" | "warning" | "danger" | "info";
    size?: "xs";
    glyph?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

type ButtonToolbarProps = {
    children: ReactNode;
}

export const ButtonToolbar = ({children} : ButtonToolbarProps) => {
    return <div className={"btn-toolbar"}>
        {children}
    </div>
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {isLoading, variant, size, glyph, ...other} = props

    let glyphClass = ""
    if (glyph && glyph.length > 0) {
        glyphClass = `rioglyph rioglyph-${glyph}`
    }

    const classes = classNames("btn", {
        "btn-default": variant === undefined,
        "btn-primary": variant === "primary",
        "btn-loading": isLoading === true,
        "disabled": isLoading === true || props.isDisabled === true,
        "btn-xs": size === "xs"

    })


    return <button ref={ref} className={classes} {...other}>
        {glyphClass && <span className={glyphClass} aria-hidden="true">
                </span>}
        <span>{props.children}</span>
    </button>
})

